@if ({
  isPasswordChangeActive: isPasswordChangeActive$ | async,
  isEmailChangeActive: isEmailChangeActive$ | async,
  userMail: userMail$ | async
}; as data) {
  <div class="section">
    @if (!data.isEmailChangeActive) {
      <div class="section__summary">
        <div class="section__info">
          <h3 class="section__title">{{ 'label.UserMail' | translate }}</h3>
          <p class="section__email">{{ data.userMail }}</p>
        </div>

        <button type="button" class="section__toggle" [disabled]="data.isPasswordChangeActive" (click)="onChangeEmail()">
          {{ 'label.ChangeEmail' | translate }}
        </button>
      </div>
    } @else {
      <div [formGroup]="editForm" #ngForm="ngForm">
        <h3 class="section__title section__title--form">{{ 'label.EditUserEmail' | translate }}</h3>

        <div class="form">
          <div class="form__field">
            <label class="form__label" for="current-email">{{ 'label.CurrentEmail' | translate }}</label>
            <input id="current-email" type="email" class="form__input" [value]="data.userMail" disabled />
          </div>

          <div class="form__field">
            <label class="form__label" for="new-email">{{ 'label.NewEmail' | translate }}</label>
            <input id="new-email" type="email" class="form__input" formControlName="newEmail" autocomplete="off" />

            @if (editForm.controls['newEmail'].touched || ngForm.submitted) {
              @if (editForm.get('newEmail')?.errors?.['required']) {
                <span class="form__error">{{ 'message.MandatoryField' | translate }}</span>
              }
              @if (editForm.get('newEmail')?.errors?.['pattern']) {
                <span class="form__error">{{ 'message.IncorrectFormat' | translate }}</span>
              }
              @if (editForm.controls['newEmail'].errors?.server) {
                <span class="form__error">{{ getValidationMessage(editForm.controls['newEmail'].errors?.server) | translate }}</span>
              }
            }
          </div>

          <div class="form__field form__field--last">
            <span class="form__label">{{ 'label.EnterCurrentPassword' | translate }}</span>
            <hrra-password-input class="form__password" formControlName="password" [withPlaceholder]="false" autocomplete="off"></hrra-password-input>

            @if (isCurrentPasswordIncorrect$ | async) {
              <span class="form__error">{{ 'message.CurrentPasswordYouEnteredIsIncorrect' | translate }}</span>
            }
            @if (editForm.get('password')?.errors?.['required'] && (editForm.controls['password'].touched || ngForm.submitted)) {
              <span class="form__error">{{ 'message.MandatoryField' | translate }}</span>
            }
          </div>

          <div class="form__buttons">
            <button type="button" class="form__save" (click)="onSave()">{{ 'label.StartEditing' | translate }}</button>
            <button type="button" class="form__cancel" (click)="onCancel()">{{ 'label.Cancel' | translate }}</button>
          </div>
        </div>
      </div>
    }
  </div>
}
